import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";

const GlobalSearchResult = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { searchResults } = state || {};
  if (!searchResults || searchResults.length === 0) {
    return <p>No data found.</p>;
  }

  const processData = (item) => {
    const aaNos = item.aaNo
      ? item.aaNo.split(",").map(s => s.trim()).filter(Boolean)
      : [];
    const imeiNos = item.imeiNo
      ? item.imeiNo.split(",").map(s => s.trim()).filter(Boolean)
      : [];

    if (aaNos.length === 0 && imeiNos.length === 0) {
      return [{ aa: "-", imei: "-" }];
    }

    return aaNos.map((aa, index) => ({
      aa,
      imei: imeiNos[index] || "-",
    }));
  };


  const ROUTE_MAP = {
    "Review Batches": "/invoice",
    "Pending Approval": "/approval",
    "Back Or Partial": "/partialApproval",
    "Back Data": "/sendBackByapproval",
    "Rejected Cases": "/rejected-cases",
    "Query Cases": "/query-case",
    "Hold Cases": "/hold-case",
    "PaidCasesMIS": "/paidPaymentMIS",
    "Raw Data MIS": "/rawdataMIS",
    "Unpaid MIS": "/pendingPaymentMIS",
    "Finance Review Batch": "https://bandlecrm.acrossassist.in/",
    "Validated Cases": "https://bandlecrm.acrossassist.in/",
    "Scheduled Or Payment Details": "https://bandlecrm.acrossassist.in/",
    "Payment History": "https://bandlecrm.acrossassist.in/",
  };

  const handleView = (item) => {
    const route = ROUTE_MAP[item.tableName] || "/";

    if (route.startsWith("http")) {
      window.location.href = route;
    } else {
      navigate(route, { state: { batchNo: item.batchNo, data: item } });
    }
  };
  return (
    <div className="container mt-4">
      <h4 style={{ textDecoration: "underline" }}>Global Search Results</h4>

      <table className="table table-bordered mt-3">
        <thead className="table-light">
          <tr>
            <th>View</th>
            <th>Stage</th>
            <th>AA No</th>
            <th>IMEI No</th>
            <th>Batch No</th>
            <th>Invoice No</th>
            <th>Vendor Name</th>
            <th>Final Payable Amount</th>
            <th>Total Paid Amount</th>
            {/* <th>Invoice Status</th> */}
            <th>Network Status</th>
            <th>Finance Status</th>
            <th>GST Status</th>
            <th>Payment Status</th>
          </tr>
        </thead>
        <tbody>
          {searchResults.map((item, idx) => {
            const filteredData = processData(item);
            return filteredData.length > 0
              ? filteredData.map((pair, i) => (
                <tr key={`${idx}-${i}`}>
                  <td className="text-center">
                    <button
                      className="btn btn-link p-0"
                      onClick={() => handleView(item)}
                      title="View Details"
                    >
                      <VisibilityIcon style={{ color: "#7E00D1" }} />
                    </button>
                  </td>
                  <td>
                    {item.tableName === "Back Or Partial"
                      ? "Partial Approval"
                      : item.tableName === "Back Data"
                        ? "Back From Approval"
                        : item.tableName === "Scheduled Or Payment Details"
                          ? "Payment Scheduled"
                          : item.tableName}
                  </td>
                  <td>{pair.aa || "-"}</td>
                  <td>{pair.imei || "-"}</td>
                  <td>{item.batchNo || "-"}</td>
                  <td>{item.invoiceNo || "-"}</td>
                  <td>{item.vendorName || "-"}</td>
                  <td>{item.finalPayableAmount || "-"}</td>
                  <td>{item.totalPaidAmount || "-"}</td>
                  <td>{item.invoiceStatus || "-"}</td>
                  <td>{item.tableName == "Payment History" ? "Payment Done" : item.financeStatus || "-"}</td>
                  <td>{item.gstStatus || "-"}</td>
                  <td>{item.paymentStatus || "-"}</td>

                </tr>
              ))
              : null;
          })}
        </tbody>

      </table>

    </div>
  );
};

export default GlobalSearchResult;
